import { ASSET_TYPE, DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'
import { cancelKeywordCommit } from './keyword'
import { initialPolygonState } from '../slices/polygon'
import { initialThreeDOnlyState } from '../slices/threeDOnly'
import { initialThreeDPrintOnlyState } from '../slices/threeDPrintOnly'

/**
 * Sets the asset type and resets the secondary chips specific to each asset
 * type, so toggles don't persist when switching type and back. Styles and tag
 * suggestions are asset-type-specific too, so they reset here (in the action,
 * not in component effects) - popstate restores assetType together with the
 * styles/tags the restored URL encodes, and an effect-based reset would wipe
 * them right back out.
 * @param {string} assetType - One of: "all", "3d_only", "3d_print_only"
 */
export const setAssetType = (assetType) => {
  if (searchPageStore.getState().assetType === assetType) return

  // Drop any keystroke still waiting to commit before the field's control goes away, so it cannot
  // land after the reset below. The input's unmount cleanup does this too; doing it here does not
  // depend on unmount ordering.
  if (assetType === ASSET_TYPE.ALL) cancelKeywordCommit()

  searchPageStore.setState(state => ({
    assetType,
    styles: DEFAULT_STATE.styles,
    tags: DEFAULT_STATE.tags,
    // The within-results keyword field lives in the secondary bar, which unmounts entirely on
    // "All assets" (SecondaryFilters returns null) while buildSearchParams keeps emitting
    // within_keywords - reset it when its control disappears. It intentionally survives
    // 3D <-> 3D Print switches, where the field stays visible.
    ...(assetType === ASSET_TYPE.ALL
      ? { keyword: DEFAULT_STATE.keyword, keywordClearCount: state.keywordClearCount + 1 }
      : {}),
    // Polygon filters are 3D-only UI (PolyCount only renders then), but buildSearchParams emits
    // polygon_range unconditionally - without this reset, leaving 3D Only would keep constraining
    // results through a filter no control shows anymore.
    ...initialPolygonState,
    ...initialThreeDOnlyState,
    ...initialThreeDPrintOnlyState,
  }))
}
